import {
    ActivatedRouteSnapshot,
    Resolve,
    RouterStateSnapshot
} from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { CommonHttpService } from '../services/http.service';
import { AppsService } from '../services/apps.service';

@Injectable()
export class AppsResolver implements Resolve<any> {
    constructor(
        protected appsService: AppsService,
        protected http: CommonHttpService
    ) { }

    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<any> {
        this.appsService.dataLoad();
        return this.appsService.loaded$;
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src4078178155/src/src/app/shared/resolvers/apps.resolver.ts